const React = require('react');
const CancelablePromise = require('mn-utils/CancelablePromise');
const delay = require('mn-utils/delay');
const trim = require('mn-utils/trim');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const handleProviderProvider = require('mn-utils/changeProviderProviderSimple');
const {
  COUNTRIES,
} = require('../../../../../constants/countries');
const withState = require('../../../../../utils/withState');
const validateUrl = require('../../../../../utils/validateUrl');
const {
  apiV2KycCompanyProfileSubmit,
} = require('../../../../../api/merchant/kyc');
const Select = require('../../../../dumb/Select/F');
const Switch = require('../../../../dumb/Switch/C');
const TextField = require('../../../../dumb/TextField/I');
const WrapperWithLoading = require('../../../../dumb/WrapperWithLoading/B');
const ButtonSave = require('../components/Button/Save');
const ButtonNext = require('../components/Button/Next');
const InputUploadDocs = require('../components/UploadDocs');


module.exports = withState((setState, self, onMount) => {
  const changeProvider = changeProviderProvider(setState);
  const handleProvider = handleProviderProvider(setState);

  const handleChangeCompanyName = changeProvider('company_name');
  const handleChangeRegNumber = changeProvider('reg_number');
  const handleChangeRegisterStreet = changeProvider('register_street');
  const handleChangeRegisterAddressLine = changeProvider('register_address');
  const handleChangeRegisterZip = changeProvider('register_zip');
  const handleChangeRegisterCity = changeProvider('register_city');
  const handleChangeRegisterCountry = handleProvider('register_country');
  const handleChangeSameAsRegisteredAddress = handleProvider('sameAsRegisteredAddress');
  const handleChangeOperatingStreet = changeProvider('operating_street');
  const handleChangeOperatingAddressLine = changeProvider('operating_address');
  const handleChangeOperatingZip = changeProvider('operating_zip');
  const handleChangeOperatingCity = changeProvider('operating_city');
  const handleChangeOperatingCountry = handleProvider('operating_country');
  const handleChangeWebsite = changeProvider('link_company_details');
  const handleChangeNature = changeProvider('nature');

  const handleChangeBusinessRegistrationExtract
    = handleProvider('docBusinessRegistrationExtract');
  const handleChangeLoadingBusinessRegistrationExtract
    = handleProvider('loadingDocBusinessRegistrationExtract');

  const handleChangeBusinessOperatingAddress
    = handleProvider('docBusinessOperatingAddress');
  const handleChangeLoadingBusinessOperatingAddress
    = handleProvider('loadingDocBusinessOperatingAddress');

  const handleChangeShareHolderStructure
    = handleProvider('docShareHolderStructure');
  const handleChangeLoadingShareHolderStructure
    = handleProvider('loadingDocShareHolderStructure');


  let _defaultState;


  function update() {
    delay(() => {
      const next = _defaultState || {};
      setState({
        sameAsRegisteredAddress: next.sameAsRegisteredAddress,
        company_name: next.company_name,
        reg_number: next.reg_number,
        nature: next.nature,
        register_country: next.register_country,
        register_city: next.register_city,
        register_street: next.register_street,
        register_address: next.register_address,
        register_zip: next.register_zip,
        operating_country: next.operating_country,
        operating_city: next.operating_city,
        operating_street: next.operating_street,
        operating_address: next.operating_address,
        operating_zip: next.operating_zip,
        link_company_details: next.link_company_details,
        docBusinessRegistrationExtract: next.docBusinessRegistrationExtract,
        docBusinessOperatingAddress: next.docBusinessOperatingAddress,
        docShareHolderStructure: next.docShareHolderStructure,
      });
    });
  }

  onMount(() => {
    self.props.onMount();
  });

  return (state, props) => {
    function field(key, def) {
      let v = state[key];
      v === undefined && (v = def);
      v === undefined && (v = '');
      return v;
    }

    const {
      handleOpenConfirm,
      handleOpenConfirmRemove,
    } = props;
    const defaultState = props.defaultState;
    const {
      clicked,
    } = state;

    const sameAsRegisteredAddress = field('sameAsRegisteredAddress', true);

    const companyName = field('company_name');
    const companyRegNumber = field('reg_number');
    const companyNature = field('nature');

    const companyCountry = state.register_country;
    const companyCity = field('register_city');
    const companyStreet = field('register_street');
    const companyAddressLine = field('register_address');
    const companyZip = field('register_zip');

    const operatingCountry = state.operating_country;
    const operatingCity = field('operating_city');
    const operatingStreet = field('operating_street');
    const operatingAddressLine = field('operating_address');
    const operatingZip = field('operating_zip');

    const website = field('link_company_details');

    const docBusinessRegistrationExtract = state.docBusinessRegistrationExtract;
    const docBusinessOperatingAddress = state.docBusinessOperatingAddress;
    const docShareHolderStructure = state.docShareHolderStructure;


    const invalidCompanyName = !trim(companyName);
    const invalidCompanyRegNumber = !trim(companyRegNumber);
    const invalidCompanyNature = !trim(companyNature);

    const invalidCompanyCountry = !companyCountry;
    const invalidCompanyCity = !trim(companyCity);
    const invalidCompanyStreet = !trim(companyStreet);
    const invalidCompanyZip = !trim(companyZip);

    const invalidOperatingCountry = !sameAsRegisteredAddress && !operatingCountry;
    const invalidOperatingCity = !sameAsRegisteredAddress && !trim(operatingCity);
    const invalidOperatingStreet = !sameAsRegisteredAddress && !trim(operatingStreet);
    const invalidOperatingZip = !sameAsRegisteredAddress && !trim(operatingZip);

    const invalidDocBusinessRegistrationExtract = !docBusinessRegistrationExtract;

    const invalidWebsite = !!website && !validateUrl(website);


    const disabled = invalidCompanyName
      || invalidCompanyRegNumber
      || invalidCompanyNature
      || invalidCompanyCountry
      || invalidCompanyCity
      || invalidCompanyStreet
      || invalidCompanyZip
      || invalidOperatingCountry
      || invalidOperatingCity
      || invalidOperatingStreet
      || invalidOperatingZip
      || invalidDocBusinessRegistrationExtract
      || invalidWebsite
      || state.loadingDocBusinessRegistrationExtract
      || state.loadingDocBusinessOperatingAddress
      || state.loadingDocShareHolderStructure;


    _defaultState === defaultState || update(_defaultState = defaultState);


    function submit() {
      if (disabled) {
        setState({
          clicked: true,
        });
        return CancelablePromise.reject();
      }
      setState({
        loading: true,
      });
      return apiV2KycCompanyProfileSubmit({
        // phone: phone,
        // source_of_wealth: sourceOfFunds,
        company_name: trim(companyName),
        reg_number: trim(companyRegNumber),
        nature: trim(companyNature),

        register_country: trim(companyCountry),
        register_city: trim(companyCity),
        register_street: trim(companyStreet),
        register_address: trim(companyAddressLine),
        register_zip: trim(companyZip),

        operating_country: trim(
          sameAsRegisteredAddress
            ? companyCountry
            : operatingCountry,
        ),
        operating_city: trim(
          sameAsRegisteredAddress
            ? companyCity
            : operatingCity,
        ),
        operating_street: trim(
          sameAsRegisteredAddress
            ? companyStreet
            : operatingStreet,
        ),
        operating_address: trim(
          sameAsRegisteredAddress
            ? companyAddressLine
            : operatingAddressLine,
        ),
        operating_zip: trim(
          sameAsRegisteredAddress
            ? companyZip
            : operatingZip,
        ),

        same_as_registered_address: sameAsRegisteredAddress,

        link_company_details: trim(website),
      }).finally(() => {
        setState({
          loading: false,
        });
      });
    }


    return (
      <WrapperWithLoading
        loading={state.loading}
      >
        <div className="cfx mh-10 (lt|ph10|w1/2|w@m)>1">
          <div>
            <TextField
              label="Business name *"
              value={companyName}
              onChange={handleChangeCompanyName}
              error={clicked && invalidCompanyName}
            />
          </div>
          <div className="mt20@m">
            <TextField
              label="Business registration number *"
              value={companyRegNumber}
              onChange={handleChangeRegNumber}
              error={clicked && invalidCompanyRegNumber}
            />
          </div>
        </div>
        <div
          className="mt20 f12 fw3 lh18 lts0em tl"
        >Business address</div>
        <div className="cfx mh-10 (lt|ph10|w1/3|w@m)>1 mt16">
          <div>
            <TextField
              label="Street and house # *"
              value={companyStreet}
              onChange={handleChangeRegisterStreet}
              error={clicked && invalidCompanyStreet}
            />
          </div>
          <div className="mt20@m">
            <TextField
              label="Address line 2"
              value={companyAddressLine}
              onChange={handleChangeRegisterAddressLine}
            />
          </div>
          <div className="mt20@m">
            <TextField
              label="ZIP / postal code *"
              value={companyZip}
              onChange={handleChangeRegisterZip}
              error={clicked && invalidCompanyZip}
            />
          </div>
        </div>
        <div className="cfx mh-10 (lt|ph10|w1/2|w@m)>1 mt20">
          <div>
            <TextField
              label="City *"
              value={companyCity}
              onChange={handleChangeRegisterCity}
              error={clicked && invalidCompanyCity}
            />
          </div>
          <div className="mt20@m">
            <Select
              placeholder="Country *"
              error={clicked && invalidCompanyCountry}
              propName="0"
              propValue="1"
              displayEmpty
              items={COUNTRIES}
              value={companyCountry}
              onChange={handleChangeRegisterCountry}
            />
          </div>
        </div>
        <div className="layoutRow fhaB fvaC mt20 dB@m">
          <div
            className="f12 fw3 lh18 lts0em tl"
          >Operating address</div>

          <div className="mt16@m">
            <Switch
              className="mv-5"
              label="Same as business address"
              checked={sameAsRegisteredAddress}
              onChange={handleChangeSameAsRegisteredAddress}
            />
          </div>
        </div>

        <div className="cfx mh-10 (lt|ph10|w1/3|w@m)>1 mt16">
          <div>
            {
              sameAsRegisteredAddress ? (
                <TextField
                  label="Street and house # *"
                  value={companyStreet}
                  disabled
                  readOnly
                />
              ) : (
                <TextField
                  label="Street and house # *"
                  value={operatingStreet}
                  onChange={handleChangeOperatingStreet}
                  error={clicked && invalidOperatingStreet}
                />
              )
            }
          </div>
          <div className="mt20@m">
            {
              sameAsRegisteredAddress ? (
                <TextField
                  label="Address line 2"
                  value={companyAddressLine}
                  disabled
                  readOnly
                />
              ) : (
                <TextField
                  label="Address line 2"
                  value={operatingAddressLine}
                  onChange={handleChangeOperatingAddressLine}
                />
              )
            }
          </div>
          <div className="mt20@m">
            {
              sameAsRegisteredAddress ? (
                <TextField
                  label="ZIP / postal code *"
                  value={companyZip}
                  disabled
                  readOnly
                />
              ) : (
                <TextField
                  label="ZIP / postal code *"
                  value={operatingZip}
                  onChange={handleChangeOperatingZip}
                  error={clicked && invalidOperatingZip}
                />
              )
            }
          </div>
        </div>
        <div className="cfx mh-10 (lt|ph10|w1/2|w@m)>1 mt16">
          <div>
            {
              sameAsRegisteredAddress ? (
                <TextField
                  label="City *"
                  value={companyCity}
                  disabled
                  readOnly
                />
              ) : (
                <TextField
                  label="City *"
                  value={operatingCity}
                  onChange={handleChangeOperatingCity}
                  error={clicked && invalidOperatingCity}
                />
              )
            }
          </div>
          <div className="mt20@m">
            {
              sameAsRegisteredAddress ? (
                <Select
                  placeholder="Country *"
                  propName="0"
                  propValue="1"
                  displayEmpty
                  items={COUNTRIES}
                  value={companyCountry}
                  disabled
                />
              ) : (
                <Select
                  placeholder="Country *"
                  propName="0"
                  propValue="1"
                  displayEmpty
                  items={COUNTRIES}
                  value={operatingCountry}
                  onChange={handleChangeOperatingCountry}
                  error={clicked && invalidOperatingCountry}
                />
              )
            }
          </div>
        </div>
        <div className="cfx mh-10 (lt|ph10|w1/2|w@m)>1 mt54">
          <div>
            <TextField
              label="Company's website"
              value={website}
              onChange={handleChangeWebsite}
              error={clicked && invalidWebsite}
            />
          </div>
          <div className="mt20@m">
            <TextField
              label="Nature of business *"
              value={companyNature}
              onChange={handleChangeNature}
              error={clicked && invalidCompanyNature}
            />
          </div>
        </div>
        <div
          className="mt30 f12 fw3 lh18 lts0em tl"
        >Provide us with supporting documents</div>
        <div className="mt10 f12 fw3 lh18 lts0em c828282">
          We need these documents to open your account with us.<br />
          Accepted types - PDF, scanned copy, clear photo JPEG, JPG, PNG and not
          more than 25 MB for each document.
        </div>
        <div className="cfx mh-10 (lt|ph10|w1/2|w@m|mb20)>1 mt20">
          <InputUploadDocs
            labelHeader="Business registration extract *"
            labelContent="Business registration extract
              provided by the country of registration."
            value={docBusinessRegistrationExtract}
            type="business_registration_extract"
            onChange={handleChangeBusinessRegistrationExtract}
            onLoading={handleChangeLoadingBusinessRegistrationExtract}
            error={clicked && invalidDocBusinessRegistrationExtract}
            openConfirm={handleOpenConfirm}
            openConfirmRemove={handleOpenConfirmRemove}
          />
          <InputUploadDocs
            labelHeader="Proof of business operating address"
            labelContent="A document, bank statement or utility bills
            not older than 3 months, containing business name and operating address."
            value={docBusinessOperatingAddress}
            type="business_operating_address"
            onChange={handleChangeBusinessOperatingAddress}
            onLoading={handleChangeLoadingBusinessOperatingAddress}
            openConfirm={handleOpenConfirm}
            openConfirmRemove={handleOpenConfirmRemove}
          />
          <InputUploadDocs
            labelHeader="Proof of shareholder structure"
            labelContent="The latest official document confirming the names
            of all directors and UBOs or shareholders (more than 20%) or other
            people with significant control."
            value={docShareHolderStructure}
            type="share_holder_structure"
            onChange={handleChangeShareHolderStructure}
            onLoading={handleChangeLoadingShareHolderStructure}
            openConfirm={handleOpenConfirm}
            openConfirmRemove={handleOpenConfirmRemove}
          />
        </div>
        <div className="layoutRow fvaC fhaB mt34">
          <ButtonSave
            disabled={disabled && clicked}
            onClick={() => {
              submit().then(props.onSubmit);
            }}
          />
          <ButtonNext
            disabled={disabled && clicked}
            onClick={() => {
              submit().then(props.handleSubmitAndNext);
            }}
          />
        </div>
      </WrapperWithLoading>
    );
  };
}, {});
